import { DEFAULT_LAYOUT } from '@/router/base';

export default {
  path: '/link',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '外链',
    icon: 'SfShare',
    order: 0,
  },
  children: [
    {
      path: 'https://sf-design.sit.sf-express.com/',
      meta: {
        title: 'sf-design',
        isLink: true,
      },
    },
    {
      path: 'https://www.sf-express.com/',
      meta: {
        title: '顺丰',
        isLink: true,
      },
    },
  ],
};
